export const AGE_GATE_COOKIE = "age_gate_choice";
export const AGE_GATE_UNLOCK_EVENT = "age-gate:unlock";
